<template>
  <div id="manage-intent" style="padding-bottom:15px;" v-if="intent">
    <div>
      <div
        class="row"
        style="padding-top:15px;border-bottom: 1px solid #eee;padding-bottom: 15px;margin-bottom: 15px;"
        :class="{'has-error': errors.has('intentName')}"
      >
        <div class="col-xs-12" style="padding-bottom: 15px;">
          <input
            type="text"
            v-if="!isDefault"
            class="form-control"
            placeholder="Intent Name"
            v-model="intent.intentname"
            name="intentName"
            data-vv-as="Intent Name"
            aria-describedby="Intent Name"
            v-validate="'required|excluded:{default}'+ (excludedName ? ','+excludedName : '')"
          >
          <div v-else>{default}</div>
          <p class="text-error" v-show="errors.has('intentName')">{{ errors.first('intentName') }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6" style="padding-bottom: 15px;">
          <p class="small" style="margin-bottom: 0px">Question</p>
          <template v-if="!isDefault">
            <div style="margin-bottom:5px;">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="intent.q_type = 'text'"
                  :class="{'btn-primary' : intent.q_type == 'text', 'btn-default' : intent.q_type != 'text'}"
                >Text</button>
              </div>
            </div>

            <div
              v-if="intent.q_type == 'text'"
              :class="{'has-error': errors.has('tags') || errorQuestionTag.length > 0}"
              style="margin-top: 15px;"
            >
              <tags
                v-model="tag"
                :tags="tags"
                @tags-changed="newTags => tags = newTags"
                @before-adding-tag="checkTag"
              ></tags>
              <!-- <vue-tags-input v-model="tag" :tags="tags" @tags-changed="newTags => tags = newTags" @before-adding-tag="checkTag" /> -->
              <input
                type="hidden"
                v-model="tags"
                name="tags"
                data-vv-as="Tags"
                v-validate="'required'"
              >
              <p class="text-error" v-show="errors.has('tags')">{{ errors.first('tags') }}</p>
              <p class="text-error" v-if="errorQuestionTag.length > 0">
                <template v-if="errorQuestionTag.includes('duplicate')">Duplicate Question</template>
              </p>
            </div>
            <input
              type="checkbox"
              id="checkbox"
              v-model="isReplyComment"
              @change="onChangeReplyComment"
              style="margin-top: 10px"
            > Comment reply
          </template>
          <template v-else>
            <br>Message
          </template>
        </div>
        <div class="col-sm-6" style="padding-bottom: 15px;">
          <p class="small" style="margin-bottom: 0px">Answer</p>
          <template v-if="isReplyComment">
            <div
              class="message"
              style="margin-bottom: 10px;float:left;position:relative;border-radius: 12px;max-width: 281px;overflow-wrap: break-word;min-height: 22px;min-width: 14px;line-height:15.36px;overflow: hidden;cursor:pointer;"
            >
              <div style="font-size: 12px;color:black">
                <template>
                  <div style="padding: 5px 8px 6px;background-color:#F1F0F0">
                    <div :class="{'has-error' : errors.has('answer_reply_comment')}">
                      <autoresize-textarea
                        :ref="'replyComment'"
                        class="form-control"
                        placeholder="Answer"
                        v-model="replyComment"
                        name="answer"
                        data-vv-as="Answer"
                        :data-vv-name="'answer_reply_comment'"
                        v-validate="'required'"
                        style="resize: none"
                        maxlength="640"
                      ></autoresize-textarea>
                      <!-- <textarea ref="answer" class="form-control" placeholder="Answer" @keyup="resizeTextarea(index)" v-model="item.value"  name="answer" data-vv-as="Answer" v-validate="'required'" style="resize: none" @keydown="onTyping"></textarea> -->
                      <span
                        class="text-error"
                        v-show="errors.has('answer_reply_comment')"
                      >{{errors.first('answer_reply_comment')}}</span>
                    </div>
                    <div class="row">
                      <div class="col-xs-12 text-left" style="margin-top: 10px;">
                        <!-- <a href="javascript:void(0);" @click="showEmoji = !showEmoji; currentIndex = index"><img src="/static/img/assets/facebook_ui/Expression.png" alt=""></a> -->
                        <intent-prefill @addIntentPrefill="addIntentPrefill($event)"></intent-prefill>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <template v-else>
            <div style="margin-bottom:5px;">
              <div class="btn-group hidden-xs hidden-sm" role="group">
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="changeIntentType('text')"
                  :class="{'btn-primary' : intent.a_type == 'text', 'btn-default' : intent.a_type != 'text'}"
                >Normal</button>
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="changeIntentType('template')"
                  :class="{'btn-primary' : intent.a_type == 'template', 'btn-default' : intent.a_type != 'template'}"
                >Generic</button>
                <button
                  type="button"
                  class="btn btn-sm"
                  v-if="welcomeMessage"
                  @click="changeIntentType(welcomeMessage.type)"
                  :class="{'btn-primary' : intent.a_type == 'message' || intent.a_type == 'generic', 'btn-default' : intent.a_type != 'message' || intent.a_type == 'generic'}"
                >Get Started</button>
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="changeIntentType('viewsummary')"
                  :class="{'btn-primary' : intent.a_type == 'viewsummary', 'btn-default' : intent.a_type != 'viewsummary' }"
                >Cart Summary</button>
                <button
                  type="button"
                  class="btn btn-sm"
                  @click="changeIntentType('none')"
                  :class="{'btn-primary' : intent.a_type == 'none', 'btn-default' : intent.a_type != 'none'}"
                >No Reply</button>
              </div>

              <select class="form-control hidden-md hidden-lg" v-model="intent.a_type">
                <option value="text">Normal</option>
                <option value="template">Generic</option>
                <option v-if="welcomeMessage" :value="welcomeMessage.type">Get Started</option>
                <option value="viewsummary">Cart Summary</option>
                <option value="none">No Reply</option>
              </select>
            </div>

            <div v-if="intent.a_type == 'text'">
              <!-- intent.a_val -->
              <intent-group v-model="intent.a_val"></intent-group>
            </div>

            <div v-else-if="intent.a_type == 'template'">
              <div style="overflow-x:scroll;margin-bottom:5px;margin-top: 15px;">
                <div
                  style="margin:0;overflow:auto;"
                  :style="{'width': ((generics.length * 315) + (generics.length < 10 ? 315 : 0)) +'px'}"
                >
                  <div
                    style="float:left;width:300px;margin-right: 15px;"
                    v-for="(generic,index) in generics"
                    :key="'generic_'+index"
                  >
                    <generic-manage
                      :vkey="index"
                      v-model="generics[index]"
                      @onDelete="onDeleteGeneric(index)"
                    >
                      <move-horizontal
                        slot="move"
                        :index="index"
                        :max="generics.length"
                        @onMove="onMove(index,$event)"
                      ></move-horizontal>
                    </generic-manage>
                  </div>

                  <div
                    v-if="generics.length < 10"
                    @click="addGeneric"
                    style="position:relative;float:left;width:300px;border: 4px dashed #eee;border-radius: 20px;height: 300px;cursor:pointer"
                  >
                    <div
                      style="position:absolute;left: 50%;top: 50%;margin-left: -10px;margin-top: -23px;font-size: 32px;"
                    >
                      <span class="glyphicon glyphicon-plus"></span>
                    </div>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>

            <div v-else-if="intent.a_type == 'message'">
              <intent-getstarted v-if="welcomeMessage" v-model="welcomeMessage"></intent-getstarted>
            </div>

            <div v-else-if="intent.a_type == 'generic'">
              <intent-getstarted v-if="welcomeMessage" v-model="welcomeMessage"></intent-getstarted>
            </div>

            <template
              v-if="intent.a_type != 'message' && intent.a_type != 'generic' && intent.a_type != 'none'  && intent.a_type != 'viewsummary'"
            >
              <p class="small" style="margin-top: 10px;">Quick Replies</p>

              <div :class="{'has-error' : errorTag.length > 0}">
                <tags
                  v-model="reply"
                  :tags="replies"
                  @tags-changed="addReplies"
                  @before-adding-tag="checkQuickReply"
                ></tags>
                <!-- <vue-tags-input v-model="reply" :tags="replies" @tags-changed="newTags => replies = newTags" @before-adding-tag="checkQuickReply" /> -->
                <p class="text-error" v-if="errorTag.length > 0">
                  <template
                    v-if="errorTag.includes('overmaxlength')"
                  >Message cannot be longer than 20 characters</template>
                  <template
                    v-else-if="errorTag.includes('overtagmax')"
                  >Quick reply cannot be more than 10</template>
                  <template v-else-if="errorTag.includes('duplicate')">Duplicate quick reply</template>
                </p>
              </div>
            </template>
            <template v-else></template>

            <div v-if="intent.a_type == 'viewsummary'">
              <view-cart-summary-viewer></view-cart-summary-viewer>
            </div>
          </template>
        </div>
      </div>

      <div class="row" style="border-top:1px solid #eee;padding-top: 15px;margin-top: 0px;">
        <div class="text-center">
          <a class="text btn btn-primary transparent btn-sm" href="javascript:void(0);" @click="showAdvanced = !showAdvanced">Advanced
            <i class="fa" :class="{'fa-angle-down' : showAdvanced , 'fa-angle-up' : !showAdvanced}"></i>
          </a>
        </div>

        <div v-show="showAdvanced" style="padding-top: 15px;">
          <div class="col-sm-6">
            <!-- <vue-single-select v-model="intent.context_in" :options="intents" placeholder="Context In"></vue-single-select> -->
            <input
              style="margin-bottom:5px;"
              type="text"
              class="form-control"
              placeholder="Context In"
              v-model="intent.context_in"
            >
          </div>
          <div class="col-sm-6">
            <!-- <vue-single-select v-model="intent.context_out" :options="intents" placeholder="Context Out"></vue-single-select> -->
            <input
              type="text"
              class="form-control"
              placeholder="Context Out"
              v-model="intent.context_out"
            >
          </div>
          <!-- <div class="clearfix"></div>
          <div class="col-sm-6">
            <vue-autosuggest
              :suggestions="filteredOptions"
              @selected="onSelected"
              :limit="10"
              :input-props="inputProps"
            ></vue-autosuggest>
          </div> -->
        </div>
      </div>

      <div class="text-center" style="margin-top: 25px;">
        <template>
          <a href="javascript:void(0);" class="btn btn-default" @click="cancelEdit">Cancel</a>
          <a href="javascript:void(0);" class="btn btn-primary" @click="saveIntent">Save</a>
        </template>
      </div>
    </div>

    <!-- <modal-dialog v-show="showEmoji" @close="showEmoji = false">
                <div slot="body">
                    <picker @select="addEmoji" color="#EF3753" :showSkinTones="false" :showPreview="false" style="z-index: 300;margin-bottom: 30px;width:100%"/>       
                </div>

                <div slot="footer">

                </div>
    </modal-dialog>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from "@/api";
import VueTagsInput from "@johmun/vue-tags-input";
import uploadfile from "@/components/elements/uploadfile";
import IntentGroup from "./IntentGroup";
import IntentGetstarted from "./IntentGetstarted";
import Draggable from "vuedraggable";
import GenericManage from "@/components/elements/GenericManage";
import MoveHorizontal from "@/components/elements/MoveHorizontal";
import AutoresizeTextarea from "@/components/elements/AutoresizeTextarea";
import IntentPrefill from "./IntentPrefill";
import { Picker } from "emoji-mart-vue";
import ModalDialog from "@/components/elements/ModalDialog";
import Tags from "@/components/elements/Tags";
import ViewCartSummaryViewer from "@/components/elements/ViewCartSummaryViewer";
import { VueAutosuggest } from "vue-autosuggest";

const dict = {
  custom: {
    intentName: {
      excluded: "Duplicate Intent Name"
    }
  }
};

export default {
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: "add"
    },
    isDefault: {
      type: Boolean,
      default: false
    },
    excludedIntentName: {
      type: String,
      default: ""
    }
  },
  components: {
    VueTagsInput,
    uploadfile,
    IntentGroup,
    IntentGetstarted,
    Draggable,
    GenericManage,
    MoveHorizontal,
    AutoresizeTextarea,
    IntentPrefill,
    Picker,
    ModalDialog,
    Tags,
    ViewCartSummaryViewer,
    VueAutosuggest
  },
  data: function() {
    return {
      showAdvanced: false,
      intent: undefined,

      tag: "",
      groups: [],
      generics: [],
      quick_reply: "",
      reply: "",
      text: "",

      errorTag: [],
      errorQuestionTag: [],

      isReplyComment: false,
      replyComment: "",
      showEmoji: false,
      excludedName: "",
      intents: [],

      selected: "",
      options: [
        {
          data: [
            "Frodo",
            "Samwise",
            "Gandalf",
            "Galadriel",
            "Faramir",
            "Éowyn",
            "Peregrine Took",
            "Boromir",
            "Legolas",
            "Gimli",
            "Gollum",
            "Beren",
            "Saruman",
            "Sauron",
            "Théoden"
          ]
        }
      ],
      filteredOptions: [],
      inputProps: {
        id: "autosuggest__input",
        onInputChange: this.onInputChange,
        placeholder: "Type 'e'"
      },
      limit: 10
    };
  },
  mounted: function() {
    let vm = this;
    document.addEventListener("keydown", e => {
      if (e.keyCode == 27) {
        vm.$emit("close");
      }
    });

    vm.$validator.localize("en", dict);

    vm.intent = Object.assign({}, vm.value);
    vm.cached_intent = Object.assign({}, vm.value);

    vm.intents = vm.excludedIntentName.split(",");
    vm.intents.push("comment");
    vm.intents.push("{default}");

    if (
      vm.type == "edit" &&
      vm.excludedIntentName &&
      vm.excludedIntentName != "" &&
      vm.intent
    ) {
      var result = [];
      var names = vm.excludedIntentName.split(",");
      $.each(names, function(index, name) {
        if (name == vm.intent.intentname) {
          names.splice(index, 1);
          return false;
        }
      });

      vm.excludedName = names.join(",");
    } else {
      vm.excludedName = vm.excludedIntentName;
    }

    if (vm.value.a_type == "text") {
    }

    if (vm.value.a_type == "template") {
      if (vm.isJsonParseable(vm.value.a_val)) {
        vm.generics = JSON.parse(vm.value.a_val);
      } else {
        vm.generics = [];
      }
    }

    if (vm.value.context_in == "comment") {
      vm.replyComment = vm.value.a_val;
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: "selectedBot",
      welcomeMessage: "welcomeMessage",
      setting: "setting"
    }),
    tags: {
      get() {
        let vm = this;
        if (vm.intent && vm.intent.q_val && vm.intent.q_val != "") {
          var tags = vm.intent.q_val.split(",");
          var result = [];
          $.each(tags, function(index, val) {
            result.push({ text: val });
          });
          return result;
        } else {
          return [];
        }
      },
      set(value) {
        let vm = this;
        var result = [];
        $.each(value, function(index, val) {
          result.push(val.text);
        });
        vm.intent.q_val = result.join(",");
      }
    },
    replies: {
      get() {
        let vm = this;
        if (vm.intent && vm.intent.quick_reply && vm.intent.quick_reply != "") {
          // console.log(vm.intent.quick_reply)
          var quick_replies = [];

          if (vm.value.a_type == "message" || vm.value.a_type == "generic") {
            if (vm.setting.welcome_quickreplies) {
              quick_replies = vm.setting.welcome_quickreplies.contentvalue.split(
                ","
              );
            }
          } else {
            quick_replies = vm.intent.quick_reply.split(",");
          }
          var result = [];
          $.each(quick_replies, function(index, val) {
            result.push({ text: val });
          });
          return result;
        } else {
          return [];
        }
      },
      set(value) {
        let vm = this;
        var result = [];
        $.each(value, function(index, val) {
          result.push(val.text);
        });
        vm.intent.quick_reply = result.join(",");
      }
    }
  },
  methods: {
    isJsonParseable: function(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    addGeneric: function() {
      this.generics.push({
        image_url: null,
        title: "",
        subtitle: "",
        buttons: [],

        enable: true
      });
    },
    saveIntent: function() {
      let vm = this;
      let data = {
        pageid: vm.selectedBot.pageid,
        intentname: vm.intent.intentname,
        q_type: vm.intent.q_type,
        q_val: vm.intent.q_val,
        a_type: vm.intent.a_type,
        a_val: vm.intent.a_val,
        context_in: vm.intent.context_in != null ? vm.intent.context_in : "",
        context_out: vm.intent.context_out != null ? vm.intent.context_out : "",
        quick_reply: vm.intent.quick_reply,
        isShow: true
      };

      if (data.a_type == "message" || data.a_type == "generic") {
        data.a_val = "{welcome_message}";
      } else if (data.a_type == "template") {
        data.a_val = JSON.stringify(vm.generics);
      } else if (data.a_type == "viewsummary") {
        data.a_val = "{viewsummary}";
      } else if (data.a_type == "none") {
        data.a_val = "";
      }

      if (vm.isReplyComment) {
        data.a_val = vm.replyComment;
      }

      vm.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            vm.goToErrorInput();
            // do stuff if not valid.
            // console.log(this.$validator.errors.items)
            return false;
          }
          if (!vm.intent.id) {
            vm.$store.dispatch("loading");
            api.addIntent(data, function(error, response) {
              if (error) {
                console.error(error);
                vm.$store.dispatch("loading");
                return;
              }
              data.id = response.id;
              vm.$emit("input", data);
              vm.$emit("saveIntent", data);
              vm.$emit("close", null);
              vm.$store.dispatch("loading");
              vm.intent = {
                intentname: "",
                q_type: "text",
                a_type: "text",
                q_val: "",
                a_val: "",
                context_in: "",
                context_out: ""
              };
              vm.cached_intent = Object.assign({}, vm.intent);
            });
          } else {
            data["id"] = vm.intent.id;
            vm.$store.dispatch("loading");
            api.editIntent(data, function(error, response) {
              if (error) {
                console.error(error);
                vm.$store.dispatch("loading");
                return;
              }
              vm.$emit("input", data);
              // console.log(data)
              vm.$emit("saveIntent", data);
              vm.cached_intent = Object.assign({}, vm.intent);
              vm.$emit("close", null);
              vm.$store.dispatch("loading");
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancelEdit: function() {
      var vm = this;
      vm.intent = Object.assign({}, vm.cached_intent);
      vm.$emit("close", null);
    },
    checkTag(obj) {
      this.errorQuestionTag = [];
      if (obj.tag.isDuplicate) {
        //this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorQuestionTag.push("duplicate");
        obj.error();
      } else obj.addTag();

      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
    },
    checkQuickReply(obj) {
      // console.log(obj)
      // if (obj.tag.text.includes(',')) alert('Letter "," is forbidden');
      // else
      // console.log('hi' ,obj)
      this.errorTag = [];
      if (obj.tag.text.length > 20) {
        this.errorTag.push("overmaxlength");
        obj.error();
      } else if (this.replies.length >= 10) {
        this.errorTag.push("overtagmax");
        obj.error();
      } else if (obj.tag.isDuplicate) {
        //this.replies.map(t => t.text).indexOf(obj.tag.text) !== -1s
        this.errorTag.push("duplicate");
        obj.error();
      } else obj.addTag();
    },
    onDeleteGeneric(index) {
      this.generics.splice(index, 1);
    },
    onMove: function(index, direction) {
      var vm = this;
      if (direction == "left") {
        vm.generics.splice(index, 0, vm.generics.splice(index - 1, 1)[0]);
      } else if (direction == "right") {
        vm.generics.splice(index, 0, vm.generics.splice(index + 1, 1)[0]);
      }
    },
    onChangeReplyComment: function() {
      if (this.isReplyComment) {
        this.intent.context_in = "comment";
        this.replyComment = "";
      } else {
        this.intent.context_in = "";
        this.replyComment = "";
      }
    },
    addIntentPrefill: function(prefill) {
      var vm = this;
      let cursorPosition = this.$refs.replyComment.$el.selectionStart;
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        "{" + prefill + "}",
        vm.replyComment.slice(cursorPosition)
      ].join("");
    },
    addEmoji: function(emoji) {
      var vm = this;
      let cursorPosition = this.$refs.answer[this.currentIndex].$el
        .selectionStart;
      vm.replyComment = [
        vm.replyComment.slice(0, cursorPosition),
        emoji.native,
        vm.replyComment.slice(cursorPosition)
      ].join("");
      vm.showEmoji = false;
    },
    changeIntentType: function(type) {
      var vm = this;
      if (
        type == "text" &&
        (vm.intent.a_type == "" || vm.intent.a_type == null)
      ) {
        this.text = this.intent.a_val;
      }

      if (vm.intent.a_type == "text") {
        this.text = this.intent.a_val;
      }

      if (type == "text") {
        this.intent.a_val = this.text;
      }
      vm.intent.a_type = type;
    },
    addReplies: function(newTags) {
      this.replies = newTags;
      // console.log(newTags,this.replies)
    },
    onSelected(option) {
      this.selected = option.item;
    },
    onInputChange(text) {
      if (text === "" || text === undefined) {
        return;
      }

      /* Full control over filtering. Maybe fetch from API?! Up to you!!! */
      const filteredData = this.options[0].data
        .filter(item => {
          return item.toLowerCase().indexOf(text.toLowerCase()) > -1;
        })
        .slice(0, this.limit);

      this.filteredOptions = [
        {
          data: filteredData
        }
      ];
    }
  },
  watch: {
    "intent.context_in": function(newVal, oldVal) {
      if (newVal == "comment") {
        this.isReplyComment = true;
      } else {
        this.isReplyComment = false;
      }
    },
    value: function(newVal, oldVal) {
      var vm = this;
      vm.intent = Object.assign({}, vm.value);
      vm.cached_intent = Object.assign({}, vm.value);

      if (vm.value.a_type == "text") {
      }

      if (vm.value.a_type == "template") {
        if (vm.isJsonParseable(vm.value.a_val)) {
          vm.generics = JSON.parse(vm.value.a_val);
        } else {
          vm.generics = [];
        }
      }

      if (vm.value.context_in == "comment") {
        vm.replyComment = vm.value.a_val;
      }
    },
    excludedIntentName: function() {
      var vm = this;
      vm.intents = vm.excludedIntentName.split(",");
      vm.intents.push("comment");
      vm.intents.push("{default}");

      if (
        vm.type == "edit" &&
        vm.excludedIntentName &&
        vm.excludedIntentName != "" &&
        vm.intent
      ) {
        var result = [];
        var names = vm.excludedIntentName.split(",");
        $.each(names, function(index, name) {
          if (name == vm.intent.intentname) {
            names.splice(index, 1);
            return false;
          }
        });

        vm.excludedName = names.join(",");
      } else {
        vm.excludedName = vm.excludedIntentName;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/view/intent/intent-manage.vue